module.exports = __webpack_public_path__ + "img/ydd_qyh_page1.e30adc29.png";